import React from 'react';
import { Button, Space, Typography } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useCashFlow } from '../common/CashFlowContext';

export default function MonthSelector() {
  const { yearMonth, setYearMonth } = useCashFlow();

  const shift = (delta) => {
    const next = dayjs(`${yearMonth.year}-${String(yearMonth.month).padStart(2, '0')}-01`)
      .add(delta, 'month');
    setYearMonth({ year: next.year(), month: next.month() + 1 });
  };

  return (
    <Space align="center" size="large" style={{ justifyContent: 'center', width: '100%', padding: '12px 0' }}>
      <Button type="text" icon={<LeftOutlined />} onClick={() => shift(-1)} />
      <Typography.Title level={4} style={{ margin: 0 }}>
        {yearMonth.year}년 {yearMonth.month}월
      </Typography.Title>
      <Button type="text" icon={<RightOutlined />} onClick={() => shift(1)} />
    </Space>
  );
}
